/**
 * Autocomplete only, except for the two names the backend reads: the property import writes
 * them and the debt to income ratio sums up the remaining debt. Their spelling mirrors
 * App\Enums\SelfDisclosure\LiabilityPositionName.
 */
export const mortgagesSuggestion = 'Hypotheken'

export const remainingDebtSuggestion = 'Restschuld'

export const liabilitySuggestions: string[] = [
  mortgagesSuggestion,
  remainingDebtSuggestion,
  'Andere Bankkredite',
  'Bürgschaften',
  'Steuerschulden',
  'Andere Verbindlichkeiten',
]
